export enum GET_PAGINATED_ORGANIZATION_STUDENTS_WITHOUT_TCE_COLUMNS {
  NAME = 'NAME',
  CPF = 'CPF',
  GROUP_NAME = 'GROUP_NAME',
  GROUP_CODE = 'GROUP_CODE',
}

export interface GetPaginatedOrganizationStudentsWithoutTceParams {
  organizationHashId: string;
  page: number;
  length: number;
  courseHashIds: string[];
  groupHashIds: string[];
  orderDirection?: 'ASC' | 'DESC';
  orderColumn?: GET_PAGINATED_ORGANIZATION_STUDENTS_WITHOUT_TCE_COLUMNS;
  search?: string;
}
